"use strict";

Page.Agl = new Class({
	Extends: Page,
	build: function build() {
		this.parent();
	}
});
//# sourceMappingURL=agl.js.map
